import { render, staticRenderFns } from "./Actualizaciones.vue?vue&type=template&id=66c7cab4&scoped=true"
import script from "./Actualizaciones.vue?vue&type=script&lang=js"
export * from "./Actualizaciones.vue?vue&type=script&lang=js"
import style0 from "./Actualizaciones.vue?vue&type=style&index=0&id=66c7cab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7cab4",
  null
  
)

export default component.exports